<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New GST Mapping & Interface
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.gstApplnInt }}</td>
                <td class="text-xs-left">{{ row.item.desc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item.gstApplnInt)"
                    query
                    @query="doQuery(row.item.gstApplnInt)"
                    remove
                    @remove="doDelete(row.item.gstApplnInt)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
      <confirm ref="confirmDelete">
        Are you sure you want to delete the selected GST Mapping and all related interface record? ({{ selectedGSTApplnInt }})
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { gstApplnInt } from '@/const/acct/gst'
export default {
  data() {
    return {
      headers: [{ text: 'GST Mapping', value: 'gstApplnInt' }, { text: 'Description', value: 'desc' }, TableConst.tableActionHeader],
      selectedGSTApplnInt: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const apiURI = this.menu.getGSTMapList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          this.items = []
          const { data } = result.data
          if (data) {
            data.map((gstMap) => {
              const convertList = {
                gstApplnInt: gstMap.gstApplnInt,
                desc: gstApplnInt[gstMap.gstApplnInt]
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.$router.push({
        name: 'gstMapReviewDet',
        params: {
          gstApplnInt: 'new'
        }
      })
    },
    doReview(gstApplnInt) {
      if (gstApplnInt) {
        this.$router.push({
          name: 'gstMapReviewDet',
          params: {
            gstApplnInt
          }
        })
      }
    },
    doQuery(gstApplnInt) {
      if (gstApplnInt) {
        this.$router.push({
          name: 'gstMapQueryDet',
          params: {
            gstApplnInt
          }
        })
      }
    },
    doDelete(gstApplnInt) {
      const apiURI = this.menu.deleteGSTMap
      if (apiURI && gstApplnInt) {
        this.selectedGSTApplnInt = gstApplnInt
        this.$refs.confirmDelete.doPopUp().then((result) => {
          if (result) {
            const expand = {
              gstApplnInt
            }
            this.$http
              .delete(expandURI(apiURI, expand))
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.fetchData()
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.gstParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
